import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { onStart } from "./redux/managers/authManager";

import Nav from "./components/sections/Nav";
import logo from "./assets/logo.png";
// Screens //
import Home from "./screens/Home";
import NewHome from "./screens/NewHome";
import About from "./screens/About";
import TermsOfUsage from "./screens/TermsOfUsage";
import Register from "./screens/Register";
import Login from "./screens/Login";
import HQ from "./screens/HQ";
import EmailVerify from "./screens/EmailVerify";
import Mission from "./screens/Mission";
import ScrollToTop from "./screens/ScrollToTop";
import Profile from "./screens/Profile";
import NotAvailable from "./screens/NotAvailable";
import CartModal from "./components/containers/CartModal";
import { SEO } from "./components/atoms/SEO";

// Footer component
function FooterComponent() {
  return (
    <Footer>
      <FooterContainer>
        <FooterSection>
          <FooterLogo src={logo} alt="Mission GAIA Logo" />
          <FooterDescription>
            Empowering young minds through interactive environmental education and gamified learning experiences.
          </FooterDescription>
        </FooterSection>
        {/* <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLinks>
            <a href="/about">About Us</a>
            <a href="/mission">Missions</a>
            <a href="/terms">Terms of Use</a>
          </FooterLinks>
        </FooterSection> */}
        <FooterSection>
          {/* <FooterTitle>Contact</FooterTitle>
          <FooterContact>
            <p>Email: <a href="mailto:hello@missiongaia.org">hello@missiongaia.org</a></p>
            <p>Follow us on social media</p>
            <SocialIcons>
              <a href="#" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
            </SocialIcons>
          </FooterContact> */}
        </FooterSection>
      </FooterContainer>
      <FooterBottom>
        <FooterCopyright>
          &copy; {new Date().getFullYear()} Evolutionary Guidance Media R&D, Inc. All rights reserved. Mission: G.A.I.A.™, Chronicles of G.A.I.A.™ and all related content are trademarks of Evolutionary Guidance Media R&D, Inc.
        </FooterCopyright>
      </FooterBottom>
    </Footer>
  );
}

const Footer = styled.footer`
  width: 100vw;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 20%, #1e40af 100%);
  color: #eaeaea;
  padding: 80px 0 40px 0;
  font-family: 'Manrope', 'Trebuchet MS', 'Segoe UI', Arial, sans-serif;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.3);

  @media (max-width: 1440px) {
    padding: 70px 0;
  }

  @media (max-width: 1280px) {
    padding: 60px 0;
  }

  @media (max-width: 1024px) {
    padding: 50px 0;
  }

  @media (max-width: 900px) {
    padding: 45px 0;
  }

  @media (max-width: 768px) {
    padding: 40px 0 20px 0;
  }

  @media (max-width: 640px) {
    padding: 35px 0 18px 0;
  }

  @media (max-width: 480px) {
    padding: 30px 0 15px 0;
  }

  @media (max-width: 375px) {
    padding: 25px 0 12px 0;
  }
`;

const FooterContainer = styled.div`
  width: 90%;
  max-width: 1700px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;

  @media (max-width: 1280px) {
    gap: 35px;
    margin-bottom: 28px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
    margin-bottom: 25px;
  }

  @media (max-width: 900px) {
    gap: 28px;
    margin-bottom: 22px;
  }

  @media (max-width: 768px) {
    gap: 25px;
    margin-bottom: 20px;
    width: 85%;
  }

  @media (max-width: 640px) {
    gap: 22px;
    margin-bottom: 18px;
    width: 90%;
  }

  @media (max-width: 480px) {
    gap: 20px;
    margin-bottom: 15px;
  }

  @media (max-width: 375px) {
    gap: 18px;
    margin-bottom: 12px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    align-items: center;
  }
`;

const FooterLogo = styled.img`
  width: 35rem;
  margin-bottom: 15px;

  @media (max-width: 1440px) {
    width: 35rem;
  }

  @media (max-width: 1280px) {
    width: 30rem;
  }

  @media (max-width: 1024px) {
    width: 25rem;
    margin-bottom: 12px;
  }

  @media (max-width: 900px) {
    width: 22rem;
  }

  @media (max-width: 768px) {
    width: 18rem;
    margin-bottom: 10px;
  }

  @media (max-width: 640px) {
    width: 15rem;
  }

  @media (max-width: 480px) {
    width: 12rem;
    margin-bottom: 8px;
  }

  @media (max-width: 375px) {
    width: 10rem;
  }
`;

const FooterDescription = styled.p`
  font-size: 0.85rem;
  line-height: 1.6;
  color: #ccc;
  margin: 0;

  @media (max-width: 1280px) {
    font-size: 0.82rem;
  }

  @media (max-width: 1024px) {
    font-size: 0.8rem;
    max-width: 600px;
  }

  @media (max-width: 900px) {
    font-size: 0.78rem;
    max-width: 550px;
  }

  @media (max-width: 768px) {
    font-size: 0.76rem;
    max-width: 500px;
    line-height: 1.55;
  }

  @media (max-width: 640px) {
    font-size: 0.74rem;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 0.72rem;
    line-height: 1.5;
  }

  @media (max-width: 375px) {
    font-size: 0.7rem;
  }
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #ffa726;
  margin-bottom: 15px;
  margin-top: 0;

  @media (max-width: 1280px) {
    font-size: 1.15rem;
    margin-bottom: 14px;
  }

  @media (max-width: 1024px) {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  @media (max-width: 768px) {
    font-size: 1.05rem;
    margin-bottom: 10px;
  }

  @media (max-width: 640px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
    margin-bottom: 8px;
  }

  @media (max-width: 375px) {
    font-size: 0.9rem;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  a {
    color: #eaeaea;
    text-decoration: none;
    font-weight: 400;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    &:hover {
      color: #ffa726;
      transform: translateX(5px);
    }
  }
`;

const FooterContact = styled.div`
  p {
    margin: 5px 0;
    font-size: 0.9rem;
    color: #ccc;

    @media (max-width: 1024px) {
      font-size: 0.88rem;
    }

    @media (max-width: 768px) {
      font-size: 0.86rem;
    }

    @media (max-width: 640px) {
      font-size: 0.84rem;
    }

    @media (max-width: 480px) {
      font-size: 0.82rem;
    }

    @media (max-width: 375px) {
      font-size: 0.8rem;
    }
  }

  a {
    color: #ffa726;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 768px) {
    gap: 12px;
    margin-top: 8px;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }

  a {
    color: #eaeaea;
    font-size: 1.5rem;
    transition: all 0.3s ease;
    
    &:hover {
      color: #ffa726;
      transform: scale(1.1);
    }

    @media (max-width: 1024px) {
      font-size: 1.4rem;
    }

    @media (max-width: 768px) {
      font-size: 1.3rem;
    }

    @media (max-width: 640px) {
      font-size: 1.25rem;
    }

    @media (max-width: 480px) {
      font-size: 1.2rem;
    }

    @media (max-width: 375px) {
      font-size: 1.1rem;
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #333;
  padding-top: 20px;
  text-align: center;
  margin-top: 40px;

  @media (max-width: 768px) {
    padding-top: 16px;
  }

  @media (max-width: 640px) {
    padding-top: 14px;
  }

  @media (max-width: 480px) {
    padding-top: 12px;
  }
`;

const FooterCopyright = styled.div`
  font-size: 0.7rem;
  color: #fff;

  @media (max-width: 1024px) {
    font-size: 0.68rem;
  }

  @media (max-width: 768px) {
    font-size: 0.69rem;
  }

  @media (max-width: 640px) {
    font-size: 0.64rem;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
  }

  @media (max-width: 375px) {
    font-size: 0.6rem;
  }
`;

function App(props) {
  const [cartOpen, setCartOpen] = useState(false);
  let history = useHistory();
  const { dispatch, cart, currentBG } = props;
  // console.log("redux props", props);
  const { email, token } = props.user;
  const [bgMode, setBgMode] = useState(1);
  const url = window.location.pathname;
  useEffect(() => {
    const { dispatch } = props;
    dispatch(onStart());
    if (url === "/") setBgMode(1);
    else setBgMode(2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location]);

  const PrivateRoute = ({ children, ...rest }) => {
    // console.log({ ...rest });
    return (
      <Route
        {...rest}
        render={({ location }) =>
          token ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location },
              }}
            />
          )
        }
      />
    );
  };

  const PublicOnlyRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          token ? (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          ) : (
            children
          )
        }
      />
    );
  };

  // console.log("app-wide rerender");
  return (
    <Router>
      <Route exact path="/">
        <SEO 
          title="Mission G.A.I.A. - Environmental Education Gaming Platform"
          description="Mission: G.A.I.A. is a dynamic edtech platform blending gamified learning with real-world environmental challenges. Interactive hero training and global missions for 9-12 year-olds, fostering ecoliteracy and social-emotional growth."
          url="/"
          type="website"
        />
      </Route>

      <Route path="/about">
        <SEO 
          title="About Mission G.A.I.A. - Environmental Education Platform"
          description="Learn about our mission to foster ecoliteracy and social-emotional growth through interactive gaming and real-world environmental challenges."
          url="/about"
        />
      </Route>

      <Route path="/mission">
        <SEO 
          title="Environmental Missions - Interactive Learning | Mission G.A.I.A."
          description="Embark on environmental missions that teach climate science, sustainability, and conservation through gamified learning experiences."
          url="/mission"
        />
      </Route>
      <ScrollToTop />
      <MainContainer bg={currentBG}>
        <Nav
          history={history}
          signedIn={!!token}
          dispatch={dispatch}
          cartTotal={cart.length}
          toggleCart={() => setCartOpen(!cartOpen)}
        />
        {cartOpen && (
          <CartModal cart={cart} onCancel={() => setCartOpen(false)} />
        )}
        <Switch>
          <PrivateRoute path="/mission/:missionID/:taskName">
            <Mission />
          </PrivateRoute>
          <PrivateRoute path="/mission/:missionID">
            <Mission />
          </PrivateRoute>
          <PrivateRoute path="/mission">
            <Mission />
          </PrivateRoute>
          <PrivateRoute path="/profile">
            <Profile />
          </PrivateRoute>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/register">
            <NotAvailable />
          </Route>
          <PublicOnlyRoute path="/confirm">
            <EmailVerify dispatch={dispatch} history={history} />
          </PublicOnlyRoute>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/terms">
            <TermsOfUsage />
          </Route>
          <Route path="/hq">
            {token ? <HQ history={history} /> : <NewHome />}
          </Route>
          <Route path="/"><NewHome /></Route>
          {/* <Route path="/">{token ? <HQ history={history} /> : <Home />}</Route> */}
          <Route><NewHome /></Route>
          {/* <Route>{token ? <HQ history={history} /> : <Home />}</Route> */}
        </Switch>
        <FooterComponent />
      </MainContainer>
    </Router>
  );
}

export default connect((state) => {
  return {
    user: state.user.data,
    cart: state.cart.cart,
    currentBG: state.currentBG.currentBG,
  };
})(App);

const MainContainer = styled.div`
  ${({ bg }) =>
    `background: url(${bg}); 
      background-size: 100% 100%;
      background-repeat: no-repeat;
      `}
`;
